import { handleActions } from 'redux-actions';

import {
  setIsSessionTimerLoading,
  setLastMessageTime,
} from '../actions/sessionTimer';

const initialState = {
  lastMessageTime: null,
  isLoading: false,
};

const sessionTimerReducer = handleActions(
  {
    [setLastMessageTime]: (state, { payload: { lastMessageTime } }) => ({
      ...state,
      lastMessageTime,
    }),
    [setIsSessionTimerLoading]: (state, { payload: { isLoading } }) => ({
      ...state,
      isLoading,
    }),
  },
  initialState
);

export { sessionTimerReducer };
